import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ApiService } from '../services/apiService';
import { PageShell } from '../components/layout/PageShell';

const CardNotUsable: React.FC = () => {
  const [searchParams] = useSearchParams();
  const cardId = searchParams.get('cardId') || '';
  const navigate = useNavigate();

  const [moderationComment, setModerationComment] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!cardId.trim()) {
      setError('Card ID is required.');
      return;
    }

    let stopped = false;
    void (async () => {
      try {
        const status = await ApiService.getSumsubKycStatus();
        if (stopped) return;

        if (status.success && status.data) {
          setModerationComment(status.data.moderationComment || null);
        } else {
          setError(status.error || 'Failed to load verification outcome');
        }
      } catch (e) {
        if (!stopped) setError(e instanceof Error ? e.message : 'Failed to load verification outcome');
      }
    })();

    return () => {
      stopped = true;
    };
  }, [cardId]);

  return (
    <PageShell showFooter={false}>
      <div className="ev-shell-card ev-shell-card--wide ev-animate-in" style={{ textAlign: 'left' }}>
        <h1 className="ev-status-title" style={{ textAlign: 'center' }}>Card not usable</h1>
        <p className="ev-status-body" style={{ textAlign: 'center', margin: '0 auto var(--ev-space-md)' }}>
          Unfortunately, we couldn&apos;t complete your identity verification. Please contact support if you need help.
        </p>

        {moderationComment && (
          <div role="status" style={{ marginTop: 'var(--ev-space-md)' }}>
            <h2 className="ev-status-title" style={{ fontSize: '18px' }}>What we need from you</h2>
            <p className="ev-status-body">{moderationComment}</p>
          </div>
        )}

        {error && (
          <p className="ev-status-body" role="alert" style={{ color: 'var(--ev-status-error)' }}>
            {error}
          </p>
        )}

        <button
          type="button"
          className="ev-btn-secondary"
          style={{ marginTop: 'var(--ev-space-lg)' }}
          onClick={() => navigate(`/card/${encodeURIComponent(cardId)}`)}
        >
          Back to card
        </button>
      </div>
    </PageShell>
  );
};

export default CardNotUsable;
